import { Button as AriaButton } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { Icon, images } from "@core/assets";

interface MobileTopBarProps {
  /** Opens the navigation drawer. */
  onOpenMenu: () => void;
}

/**
 * Sticky bar carrying the drawer trigger and the brand mark. Exists ONLY below `lg`, where the
 * sidebar is off-canvas — from `lg` up the sidebar shows the brand and the account row itself,
 * and the design has no top bar at all, so this is hidden rather than restyled.
 *
 * Deliberately NO language switcher (see Breadcrumb) and no account menu (it lives in the
 * sidebar footer, per the design).
 */
export function MobileTopBar({ onOpenMenu }: MobileTopBarProps) {
  const { t } = useTranslation("common");

  return (
    <header className="sticky top-0 z-30 flex h-16 shrink-0 items-center gap-xs border-b border-(--border-default) bg-surface-card px-md sm:px-lg lg:hidden">
      <AriaButton
        onPress={onOpenMenu}
        aria-label={t("layout.open-menu")}
        className={
          "flex size-11 shrink-0 items-center justify-center rounded-md outline-none " +
          "text-(--text-secondary) transition-colors " +
          "hover:bg-gray-50 pressed:bg-gray-100 " +
          "focus-visible:ring-2 focus-visible:ring-focus-ring"
        }
      >
        <Icon name="menu" size={24} />
      </AriaButton>
      <img
        src={images["logo-primary"]}
        alt="DZ Champions"
        className="h-7 w-auto"
      />
    </header>
  );
}
